import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { Clock, HeartHandshake, ShieldBan, Search, Gift } from 'lucide-react';
export function Features() {
  const features = [{
    icon: <Clock className="w-6 h-6 text-sage-700" data-id="element-12" />,
    title: 'El Mapa de Horarios',
    desc: 'Cuándo tomar cada suplemento para máxima absorción (Mañana, Tarde o Noche).'
  }, {
    icon: <HeartHandshake className="w-6 h-6 text-sage-700" data-id="element-13" />,
    title: 'El Diccionario de Sinergias',
    desc: 'Qué suplementos "se aman" y deben ir juntos para funcionar al 200%.'
  }, {
    icon: <ShieldBan className="w-6 h-6 text-sage-700" data-id="element-14" />,
    title: 'La Lista de Antagonismos',
    desc: 'Qué combinaciones debes separar sí o sí para no anular su efecto.'
  }, {
    icon: <Search className="w-6 h-6 text-sage-700" data-id="element-15" />,
    title: 'Protocolo de Calidad',
    desc: 'Cómo leer etiquetas como un experto para separar lo natural de lo sintético.'
  }];
  return <Section bg="cream" data-id="element-16">
      <div className="max-w-5xl mx-auto" data-id="element-17">
        <h2 className="text-3xl md:text-5xl font-bold text-center mb-4" data-id="element-18">
          Lo que obtienes hoy
        </h2>
        <p className="text-xl text-charcoal-light text-center mb-12" data-id="element-19">
          Con esta guía digital, tendrás acceso instantáneo a:
        </p>

        <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-20">
          {features.map((feat, idx) => <div key={idx} className="bg-white p-6 rounded-xl shadow-sm border border-sage-100 flex gap-4 items-start" data-id="element-21">
              <div className="bg-sage-50 p-3 rounded-lg" data-id="element-22">{feat.icon}</div>
              <div data-id="element-23">
                <h3 className="text-xl font-bold mb-2 text-sage-900" data-id="element-24">
                  {feat.title}
                </h3>
                <p className="text-charcoal-light" data-id="element-25">{feat.desc}</p>
              </div>
            </div>)}
        </div>

        <div className="bg-gradient-to-br from-sage-800 to-sage-900 p-8 md:p-10 rounded-2xl shadow-lg border border-sage-700 text-white flex flex-col md:flex-row gap-8 items-center mb-16" data-id="element-26">
          <div className="bg-terracotta p-4 rounded-full flex-shrink-0" data-id="element-27">
            <Gift className="w-10 h-10 text-white" data-id="element-28" />
          </div>
          <div data-id="element-29">
            <div className="text-terracotta font-bold tracking-wider text-sm mb-2 uppercase" data-id="element-30">
              Bono #2 Incluido
            </div>
            <h3 className="text-2xl font-bold mb-3" data-id="element-31">Checklist de compra</h3>
            <p className="text-sage-100 text-lg" data-id="element-32">
              Para identificar suplementos de origen natural, orgánicos y
              garantizados en tu próxima compra.
            </p>
          </div>
        </div>

        <div className="text-center" data-id="element-33">
          <Button href="#pricing" data-id="element-34">QUIERO MI GUÍA AHORA</Button>
        </div>
      </div>
    </Section>;
}